let getTokenSilentlyFn = null;
let logoutFn = null;

// Only these mean the Auth0 session is really gone; anything else (network blip, timeout) shouldn't log the user out.
const SESSION_EXPIRED_ERRORS = [
    "login_required",
    "consent_required",
    "interaction_required",
    "missing_refresh_token",
    "invalid_grant"
];

export const authTokenProvider = {
    initialize(getTokenSilently, logout) {
        getTokenSilentlyFn = getTokenSilently;
        logoutFn = logout;
    },

    async getToken(options) {
        if (!getTokenSilentlyFn) {
            throw new Error("Auth0 token getter not initialized");
        }

        try {
            return await getTokenSilentlyFn(options);
        } catch (error) {
            console.error("Failed to get Auth0 token:", error);

            if (!SESSION_EXPIRED_ERRORS.includes(error?.error)) {
                throw error;
            }

            try {
                if (logoutFn) {
                    logoutFn({
                        logoutParams: {
                            returnTo: window.location.href,
                        },
                    });
                } else {
                    window.location.reload();
                }
            } catch (logoutError) {
                console.error("Logout failed:", logoutError);
                window.location.reload();
            }

            throw error;
        }
    },
};